<template>
    <div class="flex flex-col flex-auto min-w-0 p-6 gap-4">
        <div class="flex-auto">
            <div>
                <img src="@/assets/icon/ic-no-renewal-bill.png" class="mx-auto" alt=""/>
            </div>
            <div class="text-a-gray-afafaf font-medium text-21 text-center -mt-6">
                คุณไม่มีกรมธรรม์ที่สามารถ<br />
                ต่ออายุได้ในตอนนี้
            </div>
            <div class="mt-6 text-center text-12 font-light text-a-gray-afafaf line-height-18">
                หากพบปัญหาการใช้งาน<br />
                ติดต่อศูนย์บริการลูกค้า ธนชาตประกันภัย <br />
                <a href="tel:023089222" class="text-a-orange-fe5000 font-medium text-12 underline">โทร. 02-308-9222</a>
            </div>
        </div>

    </div>
</template>

<script>

import { defineComponent } from 'vue';

export default defineComponent({
    setup: function () {
    },
    // components: { MainButton }
})
</script>

<style lang="scss" scoped>
.text-21 {
    font-size: 21px;
}

.line-height-18 {
    line-height: 18px;
}
</style>
